import PasswordResetForm from "../pages/authentication/ResetPassword";
import SignIn from "../pages/authentication/SignIn";
import TwoFactorAuth from "../pages/authentication/TwoFactorAuth";

export default [
  {
    path: "/",
    component: SignIn,
    isProtected: false,
  },
  {
    path: "/sign-in",
    component: SignIn,
    isProtected: false,
  },
  {
    path: "/reset-password",
    component: PasswordResetForm,
    isProtected: true,
  },
  {
    path: "/two-factor-auth",
    component: TwoFactorAuth,
    isProtected: false,
  },
  // {
  //   path: "/change-password",
  //   component: null,
  //   isProtected: false,
  // },
];
